import { useMemo, type ReactElement } from 'react';
import { usePageBreadcrumb, usePageSidebar, useStrapiApi, useStrapiParams } from '@/hooks';
import type { StrapiListRequest, StrapiListResponse, TipoEnlaceInteres } from '@/interfaces/strapi';
import { sidebarItems } from './sidebar';
import { ROUTES } from '@/constants';
import { getEnlacesInteres } from '@/services/strapi';
import { Accordion, SectionTitle } from '@/components';

export const EnlacesInteres = (): ReactElement => {
	const params = useStrapiParams({
		page: 1,
		pageSize: 100,
		sort: 'id:asc',
		populate: {
			enlaces: true,
		},
	});

	const { data, loading, error } = useStrapiApi<StrapiListResponse<TipoEnlaceInteres>, StrapiListRequest>(
		getEnlacesInteres,
		{
			autoFetch: true,
			params,
		},
	);

	usePageBreadcrumb([
		{ label: 'Información', to: ROUTES.INFORMACION_BUSCADOR_NOTARIOS },
		{ label: 'Enlaces de Interés' },
	]);

	const sidebar = useMemo(() => sidebarItems, []);
	usePageSidebar(sidebar, true);

	if (loading) return <div className="o-strapi-page">Cargando enlaces…</div>;
	if (error) return <div className="o-strapi-page">Ha ocurrido un error cargando los enlaces.</div>;

	return (
		<div>
			<SectionTitle title="Enlaces de interés" tag="h1" align="left" className="u-mb-16" />
			<Accordion
				isMultiple
				groups={data?.list ?? []}
				getGroupTitle={(g) => g.name}
				getItems={(g) => g.enlaces ?? []}
				renderItem={(e) => (
					<a href={e.url} target="_blank" rel="noopener noreferrer" title={e.name}>
						{e.name}
					</a>
				)}
				getGroupKey={(g) => g.name}
				getItemKey={(e) => e.name}
				defaultOpen={[0]}
			/>
		</div>
	);
};
